import React from 'react';
import WorkArea from '../../workarea/WorkArea';
import SideBar from '../../routing/SideBar';
import './Main.css';

export default function Main() {
  return (
    <div className='mainWrapper'>
        <SideBar />
        <WorkArea />
    </div>
  )
}